module.exports = __webpack_public_path__ + "media/images/delete-a52ac50585b365f159b3cfc200a39b9e.svg";